var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready && _vm.filteredTransferStatusEvents.length
    ? _c(
        "div",
        { staticClass: "TransferStatuses__Widget" },
        _vm._l(_vm.filteredTransferStatusEvents, function(status, index) {
          return _c(
            "b-collapse",
            {
              key: index,
              staticClass: "content",
              attrs: { open: false },
              scopedSlots: _vm._u(
                [
                  {
                    key: "trigger",
                    fn: function(props) {
                      return [
                        _c("div", { staticClass: "transfer-header" }, [
                          _c("div", { staticClass: "transfer-info" }, [
                            _c("div", [
                              _c("b", [_vm._v("מ:")]),
                              _vm._v(" " + _vm._s(status.From))
                            ]),
                            _c("div", [
                              _c("b", [_vm._v("ל:")]),
                              _vm._v(" " + _vm._s(status.To))
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "header-actions" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: props.open
                                    ? "chevron-up"
                                    : "chevron-down"
                                }
                              }),
                              _c(
                                "b-button",
                                {
                                  attrs: { loading: _vm.isLoading },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.preview(status)
                                    }
                                  }
                                },
                                [
                                  _c("b-icon", {
                                    attrs: { icon: "download-circle" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    }
                  }
                ],
                null,
                true
              )
            },
            _vm._l(status.Events, function(event, idx) {
              return _c("div", { key: idx, staticClass: "status-event" }, [
                _c("div", [
                  _c("b", [_vm._v(_vm._s(event.TransferStatus.Name))])
                ]),
                _c("div", { staticClass: "updated-by" }, [
                  _c("span", { staticClass: "datetime" }, [
                    _vm._v(_vm._s(_vm._f("date")(event.Date)))
                  ]),
                  _vm._v(' | עודכן ע"י: '),
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(
                          event.UpdatingUserName ? event.UpdatingUserName : "-"
                        ) +
                        " "
                    )
                  ])
                ]),
                event.BotError
                  ? _c("div", [
                      _c("p", { staticStyle: { width: "90px", margin: "0" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.getEventErrorMessage(event)) + " "
                        )
                      ]),
                      _c("span", [_vm._v(" " + _vm._s(event.BotError) + " ")])
                    ])
                  : _vm._e(),
                event.MissingDocumentsLink
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: event.MissingDocumentsLink,
                            target: "_blank"
                          }
                        },
                        [_vm._v("להשלמת מסמכים")]
                      )
                    ])
                  : _vm._e(),
                event.ScannedPdfUrl
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          attrs: { href: "#", title: "מסמך סרוק מהמייל" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.downloadFile(event.ScannedPdfUrl)
                            }
                          }
                        },
                        [
                          _c("b-icon", {
                            attrs: { icon: "file-document-outline" }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                event.Reference
                  ? _c("div", { staticClass: "reference" }, [
                      _vm._v(_vm._s(event.Reference))
                    ])
                  : _vm._e()
              ])
            }),
            0
          )
        }),
        1
      )
    : _c("h1", [_vm._v("אין נתוני הסבה")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }